import React from 'react'
import ErrorPage from '../../components/ErrorPage'

const Error401 = () => (
  <ErrorPage
    statusCode={401}
    icon="lock"
    title="編集リンクが無効です"
    reasons={[
      '編集リンクが再発行され、古いリンクになっている',
      'この記事の共有が停止されている',
      'リンクの一部が欠けている（コピー漏れなど）',
    ]}
    action="お手数ですが、担当者に新しい編集リンクを依頼してください。"
  />
)

export default Error401
